(function($) {
  var _intervals = [];

  function createUpdateFn(sensor, id, suffix) {
    console.log('creating update function for ', sensor);

    if(!suffix) {
      suffix = '';
    }

    return function() {
      var targetEl = id;

      if(!(targetEl instanceof jQuery))
      {
        var targetId = '#' + id + '-target';
        targetEl = $(targetId);
      }

      if(targetEl.length) {
        targetEl.parents('dl').removeClass('sensor-pulse');

        $.ajax({
          url: '/installation/get-sensor-value?sensorId=' + sensor.id,
          success: function (response) {
            targetEl.html(response.value + suffix).parents('dl').addClass('sensor-pulse');
          }
        })
      } else {
        console.log('cannot find target element', targetEl);
      }
    }
  };

  function createHistoricalView(sensor) {
    var randId = sensor.type + '-' + Math.random().toString(36).slice(2);

    $.ajax({
      url: '/installation/get-graph-container?type=' + sensor.type + '&id=' + randId,
      success: function(response) {
        $('#historical-view .live-sensors ul').prepend(response);

        if (sensor.type === 'zone') {
          $.ajax({
            url: '/installation/get-sensor-time-series?sensorId=' + sensor.id,
            success: function(response) {
              var historical = $('#sensor-' + randId + '-historical');
              historical.empty();

              for(var i = 0; i < response.length; i++) {
                var mmt = moment(response[i].created_on).format('dddd MMMM Do YYYY kk:mm'),
                  val = response[i].value,
                  row = $(document.createElement('div')).addClass('location-history');

                var date = $(document.createElement('div')).text(mmt),
                  zone = $(document.createElement('span')).addClass('badge badge-primary').text(val);

                row.append(date).append(zone);

                historical.append(row);
              }
            }
          });
        } else {
          am4core.ready(function () {
            am4core.useTheme(am4themes_animated);
            var chart = am4core.create('sensor-' + randId + '-historical', am4charts.XYChart);
            chart.padding(0, 15, 0, 15);

            // Load external data
            chart.dataSource.url = "/installation/get-sensor-time-series?sensorId=" + sensor.id;
            chart.dataSource.parser = new am4core.JSONParser();
            chart.dataSource.parser.options.dateFields = ['created_on'];
            chart.dataSource.parser.options.dateFormat = 'i';
            chart.dataSource.parser.options.numberFields = ['value'];
            chart.dataSource.parser.options.reverse = true;

            chart.leftAxesContainer.layout = "vertical";

            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;
            dateAxis.renderer.ticks.template.length = 8;
            dateAxis.renderer.ticks.template.strokeOpacity = 0.1;
            dateAxis.renderer.grid.template.disabled = false;
            dateAxis.renderer.ticks.template.disabled = false;
            dateAxis.renderer.ticks.template.strokeOpacity = 0.2;
            dateAxis.renderer.minLabelPosition = 0.01;
            dateAxis.renderer.maxLabelPosition = 0.99;
            dateAxis.keepSelection = true;
            dateAxis.minHeight = 30;

            dateAxis.baseInterval = {
              timeUnit: "hour",
              count: 1
            };
            dateAxis.tooltipDateFormat = "HH:mm, d MMMM";

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.zIndex = 1;
            valueAxis.renderer.baseGrid.disabled = false;
            // height of axis
            valueAxis.height = am4core.percent(65);
            valueAxis.title.text = '';

            valueAxis.renderer.gridContainer.background.fill = am4core.color("#000000");
            valueAxis.renderer.gridContainer.background.fillOpacity = 0.05;
            valueAxis.renderer.inside = true;
            valueAxis.renderer.labels.template.verticalCenter = "bottom";
            valueAxis.renderer.labels.template.padding(2, 2, 2, 2);

            //valueAxis.renderer.maxLabelPosition = 0.95;
            valueAxis.renderer.fontSize = "0.8em"

            var series = chart.series.push(new am4charts.LineSeries());
            series.dataFields.dateX = "created_on";
            series.dataFields.valueY = "value";
            series.tooltipText = sensor.human_readable_type + ": {valueY.value}°";
            series.name = sensor.human_readable_type;
            series.fillOpacity = 0.3;
            series.stroke = am4core.color('#ff0050');
            series.fill = am4core.color('#ff0050');
            series.tensionX = 0.75;

            chart.cursor = new am4charts.XYCursor();

            var scrollbarX = new am4charts.XYChartScrollbar();
            scrollbarX.series.push(series);
            scrollbarX.marginBottom = 20;
            scrollbarX.scrollbarChart.xAxes.getIndex(0).minHeight = undefined;
            chart.scrollbarX = scrollbarX;

            chart.events.on("datavalidated", function () {
              dateAxis.zoom({start:0.8, end:1});
            });

            $('#sensor-' + randId + '-1d').off('click').on('click', function() {
              var now = moment(),
                yesterday = moment();

              yesterday.subtract(24, 'hours');

              dateAxis.zoomToDates(yesterday.toDate(), now.toDate());
            });

            $('#sensor-' + randId + '-1w').off('click').on('click', function() {
              var now = moment(),
                aWeekAgo = moment();

              aWeekAgo.subtract(1, 'week');

              dateAxis.zoomToDates(aWeekAgo.toDate(), now.toDate());
            });

            $('#sensor-' + randId + '-1m').off('click').on('click', function() {
              var now = moment(),
                aMonthAgo = moment();

              aMonthAgo.subtract(1, 'month');

              dateAxis.zoomToDates(aMonthAgo.toDate(), now.toDate());
            });

            $('#sensor-' + randId + '-1y').off('click').on('click', function() {
              var now = moment(),
                aYearAgo = moment();

              aYearAgo.subtract(1, 'year');

              dateAxis.zoomToDates(aYearAgo.toDate(), now.toDate());
            });
          })
        }
      }
    })
  }

  function addSensor(sensor, opts) {
    var sensorDiv,
      fn,
      def = $.Deferred(),
      randId = sensor.type + '-' + Math.random().toString(36).slice(2);

    if ($('#live-view .sensor-' + sensor.type).length) {
      def.resolve();
    } else {
      $.ajax({
        url: '/installation/get-sensor-container?type=' + sensor.type,
        success: function(response) {
          $(response).prependTo($('#live-view .live-sensors ul')).attr('id', randId);
          def.resolve()
        }
      });
    }

    def.done(function() {
      $.ajax({
        url: '/installation/get-sensor-view?type_id=' + sensor.type_id,
        success: function (response) {
          sensorDiv = $(response).appendTo($('#' + randId).find('.row'));
          fn = createUpdateFn(sensor, sensorDiv.attr('id'));
          fn();

          _intervals.push(setInterval(fn, opts.timeout));

          createHistoricalView(sensor);
        }.bind(this)
      })
    })
  }

  $.fn.viewInstallation = function(opts) {
    var el = this.eq(0);
    
    openOverlay('installation-live-view');

    el.find('.close').one('click', function(e) {
      if(_intervals) {
        for(var i = 0; i < _intervals.length; i++) {
          if(_intervals[i]) {
            clearTimeout(_intervals[i]);
          }
        }
      }
    });

    $('#live-view .live-sensors ul > *').not('.add-sensor-container, .sensor-error-codes').remove();
    $('#historical-view .live-sensors ul').empty();

    window.currentInstallationId = opts.installationId;

    $.ajax({
      url: '/installation/get-sensors?id=' + opts.installationId,
      success: function(sensorData) {
        for (var i = 0; i < sensorData.length; i++) {
          addSensor(sensorData[i], opts);
        }
      }
    });
  };

  $(document).on('click', '[data-view-installation]', function(e) {
    e.preventDefault();
    e.stopPropagation();

    if ($(this).data('readonly') !== undefined) {
      $('.add-sensor-container').addClass('d-none');
    } else {
      $('.add-sensor-container').removeClass('d-none');
    }

    $('#view-installation').viewInstallation({
      installationId: $(this).data('viewInstallation'),
      timeout: 30000
    });

    return false;
  })

  $(document).on('click', '#live-view button.open-sensor-list', function() {
    $('#live-view button.open-sensor-list, #live-view button.close-sensor-list').toggleClass('d-none');

    $.ajax({
      url: '/installation/get-sensor-list?installationId=' + window.currentInstallationId,
      success: function (response) {
        $('#addSensorBody .loader').addClass('d-none');
        $('#addSensorBody .col-sm-12').append(response);
      }.bind(this)
    })
  })

  $(document).on('click', '#live-view button.close-sensor-list', function() {
    $('#live-view button.open-sensor-list, #live-view button.close-sensor-list').toggleClass('d-none');

    $('#addSensorBody .loader').removeClass('d-none');
    $('#addSensorBody .col-sm-12 > *').not('.loader').remove();
  })

  $(document).on('click', '#live-view button.add-sensor', function() {
    $.ajax({
      url: '/installation/add-sensor',
      method: 'POST',
      data: {
        InstallationAddSensorForm: {
          installation_id: window.currentInstallationId,
          x_id: $(this).attr('data-xId'),
          type_id: $(this).attr('data-type-id')
        }
      },
      success: function (sensor) {
        addSensor(sensor, {timeout: 30000});
        $(this).remove();
      }.bind(this)
    })
  });

  if (!window.__SFM) {
    window.__SFM = {};
  }
  
  window.__SFM.installation = {
    createUpdateFn: createUpdateFn
  };
})(jQuery);